var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg2Red = function Svg2Red(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-error-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#fff"
  })));
};

export default Svg2Red;